import { all, put, call, takeEvery } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/businessInfo'
import {
  getBusinessInfo,
  getOccupations,
  getActivityAreas
} from 'services'

const {
  BUSINESS_INFO_REQUEST,
  BUSINESS_INFO_SUCCESS,
  BUSINESS_INFO_ERROR
} = ACTION_TYPES

export function *businessInfo() {
  try {
    const response = yield all({
      professionalinfo: call(getBusinessInfo),
      occupations: call(getOccupations),
      activityAreas: call(getActivityAreas)
    })

    yield put({
      type: BUSINESS_INFO_SUCCESS,
      payload: response
    })
  } catch (err) {
    yield put({ type: BUSINESS_INFO_ERROR, payload: err })
  }
}

export default function *watchBusinessInfo() {
  yield all([
    takeEvery(BUSINESS_INFO_REQUEST, businessInfo)
  ])
}
